module.exports = __webpack_public_path__ + "media/images/dummy/description-a7450a2f92b4bd88afedaeede825fe8f.png";